<template>
<div>
  <sidebar-menu width="300px" :menu="menu" :collapsed="collapsed" @toggle-collapse="onToggleCollapse" @item-click="onItemClick">
    <div slot="header">
      <transition name="fade">      
        <template v-if="collapsed">
          <router-link to="/dashboard">
            <img
              :src="logoUrlIcon"
              alt
              class="logo img-fluid"
            />          
          </router-link>
        </template>
        <template v-else>
          <div>
          <router-link to="/dashboard">
            <img 
              :src="logoUrl"
              alt
              class="logo img-fluid"
            />     
          </router-link>      
          <div>
            <div class="login">Bienvenido</div>
            <div class="login"><b>{{ getUserName }}</b></div>        
          </div> 
          </div>         
        </template> 
      </transition>      
    </div>
    <span slot="toggle-icon">
      <i class="fa fa-arrows-h" aria-hidden="true"></i>
    </span>
    <span slot="dropdown-icon" style="color: white;">
      <i class="fa fa-caret-right" aria-hidden="true"></i>
    </span>
  </sidebar-menu>

  <modal name="cambiar-contrasena">
    <cambiar-contra></cambiar-contra>
  </modal>

  <modal name="registrar-usuario" v-if="isAdmin">
    <component :is="isAdmin ? 'RegistrarUsuario' : null"></component>
  </modal>

  <modal name="actualizar-usuario" v-if="isAdmin">
    <component :is="isAdmin ? 'ActualizarUsuario' : null"></component>
  </modal>

  <modal name="ayuda">
    <ayuda></ayuda>
  </modal>

  <modal name="changelog">
    <changelog></changelog>
  </modal>  
<div v-show="false">
  <button ref="changePassBtn" @click="menuBtnClick"
    onclick="$('#cambiar-contrasena-modal').modal('show');"></button>

  <button ref="registerUserBtn" @click="menuBtnClick" v-if="isAdmin"
    onclick="$('#registrar-usuario-modal').modal('show');"></button> 

  <button ref="updateUserBtn" @click="menuBtnClick" v-if="isAdmin"
    onclick="$('#actualizar-usuario-modal').modal('show');"></button> 

  <button ref="helpBtn" @click="menuBtnClick"
    onclick="$('#ayuda-modal').modal('show');"></button>        
</div>
</div>
</template>

<script>
import Modal from 'reusable/Modal';

let CambiarContra = () => import('components/Modals/CambiarContra');
let Ayuda = () => import('components/Modals/Help');
let Changelog = () => import('components/Modals/Changelog');
let RegistrarUsuario = () => import('components/Modals/RegistrarUsuario');
let ActualizarUsuario = () => import('components/Modals/ActualizarUsuario');
var $ = require('jquery');

// const separator = {
//   template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
// }
export default {
  data () {
    return {
      menu: [],
      collapsed: true,
      showChangePass: false,
      section: 'Monitorea Ducto',      
      appSections: {
        DASHBOARD:	'DASHBOARD',
        HISTORIC_ALARM: 'HISTORIC_ALARM',
        HISTORIC_REPORT: 'HISTORIC_REPORT',
        PRESION :	'PRESION',  
        BINNACLE : 'BINNACLE',
        CAMP: 'CAMP',
        DIR_GENERAL :	'DIR_GENERAL',
        DIR_TREND : 'DIR_TREND',
        REPORT_POLL :	'REPORT_POLL',
        REPORT_TABLE_POLL : 'REPORT_TABLE_POLL',
        MONITOR : 'MONITOR',
        HELP : 'HELP',
        WEB_RELEASE: 'WEB_RELEASE',
        USER_REGISTER: 'USER_REGISTER',
        HEALTH: 'HEALTH',
      },      
    };
  },
  components: {
    Modal,
    CambiarContra,
    Ayuda,
    Changelog,
    RegistrarUsuario,
    ActualizarUsuario,
  },
  computed: {
    isAdmin() {
      let user = this.$store.state.user;  
      return user && user.accessLevel && user.accessLevel === this.$store.state.AccessLevel.Admin;      
    },     
    getUserName() {
      return this.$store.state.user.name.split(' ')[0];
    },    
    logoUrl() {
      return require('imgs/logos/' + process.env.SITE_TYPE + '_VERTICAL.png');
    },  
    logoUrlIcon() {
      return require('imgs/logos/' + process.env.SITE_TYPE + '_SINGLE.png');
    },        
  },
  methods: {
    userHasAccess(appSection) {
      let user = this.$store.state.user;  
      const permissions = user && user.permissions;  
      const permission = permissions && permissions.find(x => x.appSection == appSection);
      return permission && (permission.permAdmin || permission.permRead);
    },    
    onToggleCollapse (collapsed) {
      this.collapsed = collapsed
    }, 
    menuBtnClick() {
      return false;
    },    
    onItemClick (event, item, node) {
      // console.log('onItemClick');
      // console.log(event);
      // console.log(item);
      // console.log(node);
      if(item.to === 'logout') {
        this.$store.dispatch('logout');
      } else if(item.to === 'change-pass') {
        this.$refs.changePassBtn.click();
      } else if(item.to === 'register-user' && this.isAdmin) {
        this.$refs.registerUserBtn.click();
      } else if(item.to === 'update-user' && this.isAdmin) {
        this.$refs.updateUserBtn.click();        
      } else if(item.to === 'ayuda') {
        this.$refs.helpBtn.click();
      }
    }, 
    loadMenu() {  
      var mainSubeMenu = [
        {
          title: 'Cerrar Sesión',
          to: 'logout',
          icon: 'fa fa-sign-out'
        },
        {
          title: 'Cambiar Contraseña',
          to: 'change-pass',
          icon: 'fa fa-lock'
        },                     
      ];

      if(this.userHasAccess(this.appSections.USER_REGISTER)) {
        mainSubeMenu.push({ 
            title: 'Registrar Usuario',
            to: 'register-user',
            icon: 'fa fa-user-plus'
        });
        mainSubeMenu.push({ 
            title: 'Actualizar Usuario',
            to: 'update-user',
            icon: 'fa fa-user'
        });
      }

      this.menu.push({ 
        title: 'Opciones',
        icon: 'fa fa-user',
        child: mainSubeMenu,
      }); 

      if(this.userHasAccess(this.appSections.DASHBOARD)) {
        this.menu.push({      
            href: { path: '/dashboard' },       
            title: 'Dashboard',
            icon: 'fa fa-home'
        }); 
      } 
      if(this.userHasAccess(this.appSections.HEALTH)) {
        this.menu.push({ 
            href: { path: '/salud' },  
            title: 'Salud',
            icon: 'fa fa-heartbeat'
        });            
      }
      if(process.env.SITE_TYPE === 'GAES' && this.userHasAccess(this.appSections.HISTORIC_ALARM)) {
        this.menu.push({
            href: { path: '/historico-legacy' },
            title: 'Reporte de Eventos (Histórico)',
            icon: 'fa fa-file-archive-o'
        });
      }
      if(this.userHasAccess(this.appSections.HISTORIC_ALARM)) {
        this.menu.push({ 
            href: { path: '/historico' },
            title: 'Reporte de Eventos',
            icon: 'fa fa-file-text'
        });            
      } 
      if(this.userHasAccess(this.appSections.PRESION)) {
        var submenu3 = [];
              
        submenu3.push({ 
          href: { path: '/presion' },  
          title: 'Presión por estación',
          icon: 'fa fa-globe'
        });            

        submenu3.push({ 
          href: { path: '/presionrange' },  
          title: 'Por rango de tiempo',
          icon: 'fa fa-binoculars'
        });    
        
        submenu3.push({ 
          href: { path: '/presionnormal' },  
          title: 'Presión normalizado',
          icon: 'fa fa-line-chart'
        });               

        this.menu.push({ 
            title: 'Graficas',
            icon: 'fa fa-area-chart',
            child: submenu3,
        });             
      }      
      if(this.userHasAccess(this.appSections.BINNACLE)) {
        this.menu.push({ 
            href: { path: '/bitacora' },  
            title: 'Bitácora',
            icon: 'fa fa-binoculars'
        });            
      }    
      if(this.userHasAccess(this.appSections.CAMP)) {
        this.menu.push({ 
            href: { path: '/campo' },  
            title: 'Campo',
            icon: 'fa fa-signal'
        });            
      }  
      if(this.userHasAccess(this.appSections.DIR_GENERAL) || this.userHasAccess(this.appSections.DIR_TREND)) {
        var submenu1 = [];
              
        if(this.userHasAccess(this.appSections.DIR_GENERAL)) {
          submenu1.push({ 
            href: { path: '/direccion/general' },  
            title: 'General',
            icon: 'fa fa-globe'
          });            
        }

        if(this.userHasAccess(this.appSections.DIR_TREND)) {
          submenu1.push({ 
            href: { path: '/direccion/tendencias' },  
            title: 'Tendencias',
            icon: 'fa fa-binoculars'
          });            
        }        

        this.menu.push({ 
            title: 'Analíticos',
            icon: 'fa fa-desktop',
            child: submenu1,
        });            
      }       
      
      if(this.userHasAccess(this.appSections.REPORT_POLL) || this.userHasAccess(this.appSections.REPORT_TABLE_POLL)) {
        var submenu2 = [];

        if(this.userHasAccess(this.appSections.REPORT_POLL)) {
          submenu2.push({ 
            href: { path: '/reporte/pressure' },  
            title: 'Reporte de Presión',
            icon: 'fa fa-area-chart'
          });
        }

        if(this.userHasAccess(this.appSections.REPORT_POLL)) {
          submenu2.push({ 
            href: { path: '/reporte/pressurereport' },  
            title: 'Presión por Ducto',
            icon: 'fa fa-area-chart'
          });
        }

        if(this.userHasAccess(this.appSections.REPORT_POLL)) {
          submenu2.push({ 
            href: { path: '/reporte/poll' },  
            title: 'Reportes de Poll',
            icon: 'fa fa-bar-chart'
          });
        }

        if(this.userHasAccess(this.appSections.REPORT_TABLE_POLL)) {
          submenu2.push({ 
            href: { path: '/reporte/reportepoll' },  
            title: 'Tablas de Poll',
            icon: 'fa fa-line-chart'
          });            
        }        

        this.menu.push({ 
            title: 'Estado de Sitios',
            icon: 'fa fa-battery-three-quarters',
            child: submenu2,
        });            
      }     
      
      if(this.userHasAccess(this.appSections.MONITOR)) {
        this.menu.push({ 
            href: { path: '/configuracion' },  
            title: 'Monitoreo',
            icon: 'fa fa-cog'
        });            
      } 

      if(this.userHasAccess(this.appSections.HELP)) {
        this.menu.push({ 
            to: 'ayuda',
            title: 'Ayuda',
            icon: 'fa fa-question-circle'
        });            
      }         

      if(this.userHasAccess(this.appSections.WEB_RELEASE)) {
        this.menu.push({ 
            title: 'v0.1.6',
            icon: 'fa fa-info-circle'
        });            
      }
    }, 
  },
  created() {
  },  
  mounted() {
    this.loadMenu();
  },
  updated() {
  },  
}

</script>

<style>

.logo {
    width: auto;
    height: 40px !important;
    margin: 10px auto;
    text-align: center;
    display: block;
}

.login {
  color: white;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .25s
}

.fade-enter,
.fade-leave-to {
    opacity: 0
}

.vsm--scroll-wrapper::-webkit-scrollbar {
    display: none;
}

.vsm--scroll-wrapper {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}

.v-sidebar-menu .vsm--title {
  color:var(--sidebar-menu-unselected-color);
}

.v-sidebar-menu .vsm--icon {
  color:var(--sidebar-menu-unselected-color);
}

.vsm--arrow.vsm--arrow_slot > span > i.fa-caret-right {
  color: var(--sidebar-menu-unselected-color);
}

.vsm--arrow.vsm--arrow_open.vsm--arrow_slot  > span > i.fa-caret-right {
  color: var(--sidebar-menu-selected-color);
}


.v-sidebar-menu .vsm--link_hover {
  text-decoration: none !important;
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active, .v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  box-shadow: 3px 0px 0px 0px var(--menu-color) inset;
  background-color: var(--sidebar-menu-selected-background-color);
}

.v-sidebar-menu .vsm--toggle-btn {
  color: var(--sidebar-menu-expander-toogle-btn-color); 
}

.vsm--arrow .vsm--arrow_slot span {
  color: var(--md-theme-default-primary);
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 {
    background-color: var(--md-theme-default-accent);
}

.v-sidebar-menu .vsm--mobile-bg {
    background-color:  var(--md-theme-default-accent);
}

/* .v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon, 
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon
{
    color: var(--md-theme-default-primary);
    background-color:  var(--md-theme-default-accent);
} */

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 > .vsm--title {
    color: var(--sidebar-menu-selected-color);
}

.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon, 
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon > .vsm--icon
{
    color: var(--sidebar-menu-selected-color);
    background-color:  var(--sidebar-menu-background-open-icon-color);
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 > .vsm--icon {
  color: var(--sidebar-menu-selected-color);
  background-color:  var(--sidebar-menu-background-open-icon-color);
}

.v-sidebar-menu.vsm_collapsed .vsm--item.vsm--item_open,
.vsm--link.vsm--link_mobile-item > .vsm--title{
  color: var(--sidebar-menu-selected-color);
}

.v-sidebar-menu .vsm--link_hover, .v-sidebar-menu .vsm--link:hover {
    background-color: var(--sidebar-menu-hover-color);
}

.vsm--arrow vsm--arrow_open vsm--arrow_slot span {
  color: var(--sidebar-menu-text-color-selected);
}

.vsm--arrow .vsm--arrow_slot > span {
  color: var(--sidebar-menu-text-color-unselected) !important;
}

.vsm--toggle-btn_slot:hover, .vsm--toggle-btn_slot:focus, .vsm--toggle-btn_slot:active {
    background-color: transparent;
}

.v-sidebar-menu .vsm--link:hover > .vsm--title {
    color: var(--sidebar-menu-color-hover);
}

.v-sidebar-menu .vsm--link:hover > .vsm--icon {
    color: var(--sidebar-menu-color-hover);
}

.v-sidebar-menu .vsm--link:hover > .vsm--arrow > span > i.fa-caret-right {
    color: var(--sidebar-menu-color-hover);
}


</style>



// WEBPACK FOOTER //
// Menu.vue?2866ae30